import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createMenusTranslation: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      locale: "",
      name: "",
      menuUID: null,
      placeholder: ""
    }))()
  }))(),
  createMenusTranslationMenuItems: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      fieldType: "",
      value: "",
      description: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/menuTranslations/forms.js